//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

	export default {
		props:['acr001','type','list','epId'],
		data() {
			return {
				details: {},
				restday:'',
			}
		},
		watch: {
			details(){
				this.restday = this.datedifferent()
			},
			acr001(){
				this.getDetail()
			}
		},
		methods: {
			datedifferent() {
				let iDays
				if(this.details.aar021){
					let deadline = this.details.aar021.replace(/[.]/g,'-')
					let currentdata = new Date().toLocaleDateString().replace(/[/]/g,'-')
					let dateSpan
					let tempDate
	        currentdata = Date.parse(currentdata);
	        deadline = Date.parse(deadline);
	        dateSpan = deadline - currentdata;
	        dateSpan = Math.abs(dateSpan);
	        iDays = Math.floor(dateSpan / (24 * 3600 * 1000));
				}
        return iDays
			},
			getDetail () {
	   		let data={
	        acr001: this.acr001
	      }
        this.$https.post(this.BASE_URL+"cfs/zc/project/getLoadxmxx",
          data,
        )
        .then(res => {
          this.details = res.data.data;
          this.$emit("listenListItem",this.details)
        })
        .catch(function(err) {
        	console.log(err);
        })
	   	},
	   	toListDetail(groupdonationId,acr001) {
	   		// 列表进入详情
	   		this.$router.push('/dTDetail/'+groupdonationId+'/'+acr001+'/'+this.epId+"/false")
	   	},
	   	// toZcDetail() {
	   	// 	// 进入众筹详情页
	   	// 	this.$router.push('/zcprojectDetail/'+this.acr001)
	   	// }
		},
		computed:{
			alreadyMoney() {
				let money = this.type === 'detail'?this.details.alreadyMoney:this.list.donateNum
				if(money >= 1000000){
					let divide = money/10000
					return divide.toFixed(3).slice(0,-1)
				}else{
					return money
				}
			}
		},
		created() {
			if(this.type === 'detail') {
				this.getDetail()
				this.restday = this.datedifferent()
			}
		}
	}



// WEBPACK FOOTER //
// ./src/components/donateTogether/listItem.vue